var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":true,"color":"grey lighten-2","icon":"mdi-alert"}},[_c('caption',{staticClass:"d-inline"},[_c('b',[_vm._v("Sorry, nothing to display here.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }